import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GenericList } from './models/generic-list';

import { ServicerProvider } from './servicer';
import { SystemAlerts } from './models/system-alerts';
import { SystemAlertsApiParameter } from './models/system-alerts-parameter';

const BASE_URL = '/v2/system/alerts';

/**
 * [システム] アラート のプロバイダー.
 */
@Injectable()
export class SystemAlertsServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * Alerts情報を取得.
   *
   * @returns Observable<GenericList<SystemAlerts>>
   */
  getAlerts(parameter: SystemAlertsApiParameter): Observable<GenericList<SystemAlerts>> {
    const url = `${BASE_URL}`;
    return this.servicer.postApi<SystemAlertsApiParameter, GenericList<SystemAlerts>>(url, parameter);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-alerts-service.ts